import { useQuery } from '@tanstack/react-query';
import { getDiseaseProtocolById } from 'api/auth.api';

export const useDiseaseProtocolById = (id) => {
  return useQuery({
    queryKey: ['diseaseProtocolById', id],
    queryFn: () => getDiseaseProtocolById(id),
    enabled: !!id,
  });
};
